import { render, staticRenderFns } from "./FeedBackCallVue.vue?vue&type=template&id=525c6012&scoped=true"
import script from "./FeedBackCallVue.vue?vue&type=script&lang=js"
export * from "./FeedBackCallVue.vue?vue&type=script&lang=js"
import style0 from "./FeedBackCallVue.vue?vue&type=style&index=0&id=525c6012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525c6012",
  null
  
)

export default component.exports